export default __webpack_public_path__ + "static/media/Erica.4bc4fffc.jpg";